//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNavigation from '~/components/BottomNavigation.vue';
import Notification from '~/components/Notification';
import CartSidebar from "~/components/CartSidebar";
import RegisterFormModal from "~/themes/fiskarsMoominDefault/components/components/organisms/RegisterFormModal/RegisterFormModal.vue"
import LoginFormModal from "~/themes/fiskarsMoominDefault/components/components/organisms/LoginFormModal/LoginFormModal.vue"
import { ref, onMounted, computed } from "@nuxtjs/composition-api";
import { useUiState, useUserAccount } from '~/composables';
import { useUserStore } from '~/stores/user-store'
import { getUserRegisterLabels,getUserLoginLabels } from '~/helpers/globalLabels';
import LocaleSelectorModal from "~/components/LocaleSelectorModal.vue";
import ChangeLocaleModal from "~/components/ChangeLocaleModal.vue";
import { useVSFContext } from "@vue-storefront/core";
import { COOKIES } from "~/helpers/constants";

export default {
  name: 'LayoutShell',
  components: {
    ChangeLocaleModal,
    LocaleSelectorModal,
    BottomNavigation,
    Notification,
    CartSidebar,
    LoginFormModal,
    RegisterFormModal
  },
  setup() {
    //Login model
    const { isLoginModalOpen, toggleLoginModal, isRegisterModalOpen, toggleRegisterModal } = useUiState();
    const { isAuthenticated } = useUserAccount('user-account-info');
    const { app: {$cookies}, i18n: { locales, localeProperties }, } = useVSFContext();
    const showLoginModal = ref(true);
    const userState = useUserStore();

    const { toggleCountryConfirmationModal } = useUiState();

    //will replace once viral finishes implementing the geolocation
    const DUMMY_GEOLOCATION_COUNTRY_CODE =  $cookies.get('userCurLocation');

    const _myLocale = computed(() => locales?.find((language) => language.baseStoreCode === DUMMY_GEOLOCATION_COUNTRY_CODE))
    const _myLocaleCountryName = computed(() => _myLocale.value?.country);
    const _myLocaleCode = computed(() => _myLocale.value?.code);
    const _selectedLocale = computed(() => locales?.find((language) => language.baseStoreCode === localeProperties.baseStoreCode));
    const _selectedLocaleCountryName = computed(() => _selectedLocale.value?.country);
    const cookie_keepLocale = $cookies.get(COOKIES.CONFIRMATION_LOCALE_CHANGE, true);


    onMounted(() => {
      if(_myLocale.value && _myLocale.value?.countryCode !==  _selectedLocale.value?.countryCode && !cookie_keepLocale) toggleCountryConfirmationModal();
      // toggleCountryConfirmationModal();
      userState.updateUserStatus(isAuthenticated.value)
    });

    const loggedInEmit = (response) => {
      if(isLoginModalOpen.value)
      toggleLoginModal();
      if (response.status === 200) {
        userState.updateUserStatus(true)
      }
    }

    const registerInEmit = (response) => {
      if(isRegisterModalOpen.value)
      toggleRegisterModal();
    }

    const toggleSignupModel = (response) => {
      toggleLoginModal();
      toggleRegisterModal();
    }

    const loginFormValue = getUserLoginLabels()
    const registerFormValue = getUserRegisterLabels()

    const loginModalTexts = {
      title: loginFormValue?.document?.title,
      description: loginFormValue?.document?.description?.value,
      email:loginFormValue?.document?.email,
      emailplaceholdertext: loginFormValue?.document?.emailplaceholdertext,
      emailvalidationmessage: loginFormValue?.document?.emailvalidationmessage,
      emailformatvalidationmessage: loginFormValue?.document?.emailformatvalidationmessage,
      password:loginFormValue?.document?.password,
      passwordplaceholdertext: loginFormValue?.document?.passwordplaceholdertext,
      passwordvalidationmessage: loginFormValue?.document?.passwordvalidationmessage,
      captcha: {
        contentType: loginFormValue?.document?.captcha?.contentType,
        value: loginFormValue?.document?.captcha?.value
      },
      buttontext: loginFormValue?.document?.buttontext,
      forgotpasswordtext: loginFormValue?.document?.forgotpasswordtext,
      forgotpasswordlink: loginFormValue?.forgotpasswordlink
    }

    const registerModalTexts = {
      title: registerFormValue?.document?.title,
      firstName:registerFormValue?.document?.firstname,
      firstNamePlaceholder: registerFormValue?.document?.firstnameplaceholdertext,
      firstNameErrorMessage:registerFormValue?.document?.firstnamevalidationmessage,
      lastName:registerFormValue?.document?.lastname,
      lastNamePlaceholder: registerFormValue?.document?.lastnameplaceholdertext,
      LastNameErrorMessage:registerFormValue?.document?.lastnamevalidationmessage,
      emailLabel:registerFormValue?.document?.email,
      emailPlaceholder:registerFormValue?.document?.emailplaceholdertext, //this needs to be Email address
      emailErrorMessage: registerFormValue?.document?.emailvalidationmessage ,
      emailFormatErrorMessage: registerFormValue?.document?.emailformatvalidationmessage,
      passwordLabel:registerFormValue?.document?.password,
      passwordPlaceholder: registerFormValue?.document?.passwordplaceholdertext,
      passwordErrorMessage:registerFormValue?.document?.passwordvalidationmessage,
      passwordRequirementsLabel:registerFormValue?.document?.passwordsecuritytext,
      passwordSecurityErrorMessage:registerFormValue?.document?.passwordsecurityvalidationmessage,
      requirementEightCharacters:registerFormValue?.document?.characterslimittext,
      requirementSpecialCharacter:registerFormValue?.document?.specialcharacterstext,
      requirementUpperLowerCase:registerFormValue?.document?.upperlowercasetext,
      requirementContainsNumber:registerFormValue?.document?.numbertext,
      termsAndConditions:registerFormValue?.document?.termsandcondition?.value,
      termsAndConditionsError:registerFormValue?.document?.termsandconditionvalidationmessage,
      captchaText:registerFormValue?.document?.captchatext?.value,
      subscribeLabel:registerFormValue?.document?.consentmessage,
      submitButton:registerFormValue?.document?.buttontext,

    }


    return {
      loginModalTexts,
      showLoginModal,
      toggleLoginModal,
      loggedInEmit,
      isLoginModalOpen,
      registerModalTexts,
      isRegisterModalOpen,
      toggleRegisterModal,
      registerInEmit,
      toggleSignupModel,
      _myLocaleCountryName,
      _selectedLocaleCountryName,
      _myLocaleCode,
    }
  }
}
